import AiAgentAsCsDetails from '../../../../../components/units/Management/AiAgent/AsCs/Details';

export default function AiAgentAsCsDetailsPage() {
  return <AiAgentAsCsDetails />;
}
